import { z } from 'zod'
import { EmailSchema } from '#app/utils/user-validation.ts'

export function getSubmitRentalSchema({ isLoggedIn }: { isLoggedIn: boolean }) {
	return z
		.object({
			intent: z.literal('submit-rental'),
			title: z.string('Title is required').min(1),
			categoryId: z.string('Category is required').min(1),
			cityIds: z.array(z.string('City is required')).default([]),
			featuredMediaId: isLoggedIn
				? z.string('Image is required').min(1)
				: z.string().optional(),
			description: z.string('Description is required'),
			dailyRate: z.preprocess(
				(val) =>
					val === '' || val === null || val === undefined
						? undefined
						: Number(val),
				z
					.number()
					.min(0, { message: 'Daily rate must be positive' })
					.optional(),
			),
			hourlyRate: z.preprocess(
				(val) =>
					val === '' || val === null || val === undefined
						? undefined
						: Number(val),
				z
					.number()
					.min(0, { message: 'Hourly rate must be positive' })
					.optional(),
			),
			contactName: z.string().default(''),
			contactEmail: EmailSchema.optional(),
		})
		.superRefine((data, ctx) => {
			if (!isLoggedIn) {
				if (!data.contactName || data.contactName.trim().length < 3) {
					ctx.addIssue({
						path: ['contactName'],
						code: 'custom',
						message: 'Name is required',
					})
				}
				if (!data.contactEmail) {
					ctx.addIssue({
						path: ['contactEmail'],
						code: 'custom',
						message: 'Email is required',
					})
				}
			}
		})
}

export interface SubmitRentalForm {
	intent: 'submit-rental'
	title: string
	categoryId: string
	cityIds: string[]
	featuredMediaId?: string
	description?: string
	dailyRate?: number
	hourlyRate?: number
	contactName?: string
	contactEmail?: string
}
